import { Injectable } from '@angular/core';
import { getPreloadedConfig, preloadAppConfig } from '~/constants/config.constant';
import { AppConfig } from '../modal/appconfig.model';


@Injectable({
    providedIn: 'root',
})
export class AppConfigService {
    private config: AppConfig | null = null;
    private initPromise: Promise<boolean> | null = null;

    constructor() {
        this.config = getPreloadedConfig();
    }

    /**
     * Async init method for compatibility with APP_INITIALIZER pattern.
     */
    public async init(): Promise<boolean> {
        if (this.config) {
            return true;
        }

        const initPromise = this.initPromise ??= preloadAppConfig()
            .then((loadedConfig: AppConfig) => {
                this.config = loadedConfig;
                return true;
            })
            .catch(() => {
                this.config = {} as AppConfig;
                return false;
            });

        return initPromise;
    }

    /**
     * Set config directly (useful for testing)
     */
    public setConfig(config: AppConfig): void {
        this.config = config;
    }

    public getConfig(key?: string | Array<string>): any {
        if (!this.config) {
            throw new Error('Configuration not loaded. Ensure init() is called before getConfig().');
        }

        if (!key || (Array.isArray(key) && !key[0])) {
            return this.config;
        }

        if (!Array.isArray(key)) {
            key = key.split('.');
        }

        return key.reduce((acc: any, current: string) => acc?.[current], this.config);
    }
}
